import React from "react";
import style from "./index.module.scss";
import { TopicsItem } from "../../../../../../../API/exercise";
import PageRadioDetail from "../PageRadioDetail";
import PageCheckBoxDetail from "../PageCheckBoxDetail";
import PageJudgeDetail from "../PageJudgeDetail";
import PageSubjectiveDetail from "../PageSubjectiveDetail";
import PageGapFillingDetail from "../PageGapFillingDetail";

interface PageRadioProps {
    data: TopicsItem;
    stuDoFlg: string;
    viewPaper: string; //主观题在活动结束的时候老师未批也需要显示x号
}

export default function PageReadingDetail({
    data,
    stuDoFlg,
    viewPaper
}: PageRadioProps) {
    return (
        <div className={style.root}>
            <div className={style.top}>
                <span className={style.index}>{data.index}. </span>
                <span className={style.score}>
                    （{data.typeName}，{data.score}分）
                </span>
                <div className={style.title}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: data.contentText
                        }}
                    />
                </div>
            </div>
            {data.questions.map((item, index) => {
                return (
                    <div key={index} className={style.subStyle}>
                        {item.queTypeId.toString() === "1" && (
                            <PageRadioDetail
                                data={item}
                                stuDoFlg={stuDoFlg}
                                index={index + 1}
                            />
                        )}
                        {item.queTypeId.toString() === "2" && (
                            <PageCheckBoxDetail
                                data={item}
                                stuDoFlg={stuDoFlg}
                                index={index + 1}
                            />
                        )}
                        {item.queTypeId.toString() === "3" && (
                            <PageJudgeDetail
                                data={item}
                                stuDoFlg={stuDoFlg}
                                index={index + 1}
                            />
                        )}
                        {item.queTypeId.toString() === "4" && (
                            <PageSubjectiveDetail
                                data={item}
                                stuDoFlg={stuDoFlg}
                                index={index + 1}
                                viewPaper={viewPaper}
                            />
                        )}
                        {item.queTypeId.toString() === "5" && (
                            <PageGapFillingDetail
                                data={item}
                                stuDoFlg={stuDoFlg}
                                index={index + 1}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
